import React from "react";

function Separator(props) {
  return (
    <div
      style={{
        position: "absolute",
        height: "100%",
        transform: `rotate(${props.turns}turn)`
      }}
    >
      <div style={props.style} />
    </div>
  );
}

function RadialSeparators(props) {
  const turns = 1 / props.count;
  const range1 = Array.from(Array(props.count).keys())
  return range1.map(index => (
    <Separator key= {index} turns={index * turns} style={props.style} />
  ));
}

export default RadialSeparators;
